// common/services/user/listMeFamily.ts
import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

/** Relationship object returned per player by GET /users/me/family
 *  (under the `relationship_type` key). */
export type MeFamilyRelationship = {
  id: number
  name: string
}

/**
 * Minimal shape consumed by the Profile screen. The endpoint returns more
 * fields than this — the unknown bag keeps unrelated consumers from breaking.
 */
export type MeFamilyPlayer = {
  id: string
  relationship_type?: MeFamilyRelationship | null
  /**
   * Whether the current user is PRIMARY (administrative) for this player. Drives
   * whether the Family Management modal exposes the per-row edit/remove actions.
   */
  is_primary?: boolean | null
} & Record<string, unknown>

/**
 * GET /users/me/family — the current user's linked player profiles for the
 * Profile screen. Returns the raw player list; consumers derive selection /
 * stats visibility at the call site.
 */
export const listMeFamily = async (): Promise<MeFamilyPlayer[]> => {
  const { data } = await req(ENDPOINTS.USERS.GET_ME_FAMILY())
  return Array.isArray(data) ? (data as MeFamilyPlayer[]) : []
}
